/**
 * Whether the "start your shift" prompt has been put off. It lives in session
 * storage and is cleared on every sign-in, so "not now" lasts until the person
 * next signs in — every sign-in shows them the shift controls again.
 */

const KEY = 'viganium.shiftPrompt';

export function resetShiftPrompt(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Storage can be unavailable (a locked-down browser); the prompt then simply shows.
  }
}

export function dismissShiftPrompt(): void {
  try {
    sessionStorage.setItem(KEY, 'dismissed');
  } catch {
    // Not remembered, then — it still goes away for this page view.
  }
}

export function shiftPromptDismissed(): boolean {
  try {
    return sessionStorage.getItem(KEY) === 'dismissed';
  } catch {
    return false;
  }
}
